/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import UploadFileAPI from "../../Api/uploadFIleApi";
import UploadIcon from "../../assets/image/upload_icon.svg";

const FileUpload = ({
  label,
  name,
  register,
  required,
  errors,
  nameInsideDiv,
  setValue,
  accept,
  getValues,
}) => {
  const inputRef = useRef();
  const [selectedFile, setSelectedFile] = useState(null);
  const { accessToken } = useSelector((state) => state.adminReducers);

  const SelectedValue = getValues(name)

  useEffect(() => {
    register(name, {
      required: required ? "File is required" : false,
      validate: {
        acceptedExtensions: (fileList) => {
          const file = fileList?.[0];
          if (!file) return true;
          const allowedExtensions = [".pem", ".key"];
          const fileName = file.name.toLowerCase();
          const isValid = allowedExtensions.some((ext) =>
            fileName.endsWith(ext)
          );
          return isValid || "Only .pem or .key files are allowed";
        },
        fileSize: (fileList) => {
          const file = fileList?.[0];
          return (
            !file || file.size <= 5 * 1024 * 1024 || "Max file size is 5MB"
          );
        },
      },
    });
  }, [register, name, required]);


  const handleRemove = () => {
    setSelectedFile(null);
    setValue(name, null); 
    if (inputRef.current) inputRef.current.value = null; 
  };


  return (
    <div className="file-upload-container form-group" style={{ width: "100%" }}>
      {label && (
        <label className="file-label label_class_name_for_input">
          {label} <span style={{ color: "#FF3939" }}>*</span>
        </label>
      )}

      {(selectedFile || SelectedValue)? (
        <div
          className="form-control input-common Poppins_400 d-flex justify-content-between align-items-center certificate_upload_content">
          <span>{selectedFile?.name || SelectedValue?.original_name}</span>
          <button
            type="button"
            className="certificate_upload_content_remove"
            onClick={handleRemove}>
            ✕
          </button>
        </div>
      ) : (
        <div
          className="form-control input-common Poppins_400 certificate_upload_div"
          onClick={() => inputRef.current?.click()}>
          <img src={UploadIcon} alt="upload-icon" />
          {nameInsideDiv}
        </div>
      )}

      <input
        type="file"
        ref={inputRef}
        name={name}
        onChange={async (e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          const formData = new FormData();
          formData.append("file", file, file.name);

          try {
            const response = await UploadFileAPI(accessToken, formData);
            if (response?.status === 200) {
              setValue(name, response); 
              setSelectedFile(file);
            } else {
              console.log("Upload failed", response);
            }
          } catch (err) {
            console.log("Upload error", err);
          }
        }}
        style={{ display: "none" }}
        id={`file-${name}`}
        accept={accept}
      />

      {errors[name] && <p className="input_error">{errors[name]?.message}</p>}
    </div>
  );
};

export default FileUpload;
